// @generated by protoc-gen-es v2.11.0 with parameter "ts_nocheck=true,target=ts"
// @generated from file sync-down.proto (package Vault, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { RecordKeyType, TimerNotificationType } from "./record_pb";
import { file_record } from "./record_pb";
import type { BreachWatchInfoType } from "./breachwatch_pb";
import { file_breachwatch } from "./breachwatch_pb";
import type { LoginType } from "./api-request_pb";
import { file_api_request } from "./api-request_pb";
import type { AppClientType } from "./enterprise_pb";
import { file_enterprise } from "./enterprise_pb";
import type { NotificationWrapper } from "./notification-center_pb";
import { file_notification_center } from "./notification-center_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file sync-down.proto.
 */
export const file_sync_down: GenFile =
  /*@__PURE__*/
  fileDesc(
    "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",
    [file_record, file_breachwatch, file_api_request, file_enterprise, file_notification_center],
  );

/**
 * @generated from message Vault.SyncDownRequest
 */
export type SyncDownRequest = Message<"Vault.SyncDownRequest"> & {
  /**
   * @generated from field: bytes continuationToken = 1;
   */
  continuationToken: Uint8Array;

  /**
   * @generated from field: int32 dataVersion = 2;
   */
  dataVersion: number;
};

/**
 * Describes the message Vault.SyncDownRequest.
 * Use `create(SyncDownRequestSchema)` to create a new message.
 */
export const SyncDownRequestSchema: GenMessage<SyncDownRequest> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 0);

/**
 * @generated from message Vault.SyncDownResponse
 */
export type SyncDownResponse = Message<"Vault.SyncDownResponse"> & {
  /**
   * @generated from field: bytes continuationToken = 1;
   */
  continuationToken: Uint8Array;

  /**
   * @generated from field: bool hasMore = 2;
   */
  hasMore: boolean;

  /**
   * @generated from field: Vault.CacheStatus cacheStatus = 3;
   */
  cacheStatus: CacheStatus;

  /**
   * @generated from field: repeated Vault.UserFolder userFolders = 4;
   */
  userFolders: UserFolder[];

  /**
   * @generated from field: repeated Vault.SharedFolder sharedFolders = 5;
   */
  sharedFolders: SharedFolder[];

  /**
   * @generated from field: repeated Vault.UserFolderSharedFolder userFolderSharedFolders = 6;
   */
  userFolderSharedFolders: UserFolderSharedFolder[];

  /**
   * @generated from field: repeated Vault.SharedFolderFolder sharedFolderFolders = 7;
   */
  sharedFolderFolders: SharedFolderFolder[];

  /**
   * @generated from field: repeated Vault.Record records = 8;
   */
  records: Record[];

  /**
   * @generated from field: repeated Vault.RecordMetaData recordMetaData = 9;
   */
  recordMetaData: RecordMetaData[];

  /**
   * @generated from field: repeated Vault.NonSharedData nonSharedData = 10;
   */
  nonSharedData: NonSharedData[];

  /**
   * @generated from field: repeated Vault.RecordLink recordLinks = 11;
   */
  recordLinks: RecordLink[];

  /**
   * @generated from field: repeated Vault.UserFolderRecord userFolderRecords = 12;
   */
  userFolderRecords: UserFolderRecord[];

  /**
   * @generated from field: repeated Vault.SharedFolderRecord sharedFolderRecords = 13;
   */
  sharedFolderRecords: SharedFolderRecord[];

  /**
   * @generated from field: repeated Vault.SharedFolderFolderRecord sharedFolderFolderRecords = 14;
   */
  sharedFolderFolderRecords: SharedFolderFolderRecord[];

  /**
   * @generated from field: repeated Vault.SharedFolderUser sharedFolderUsers = 15;
   */
  sharedFolderUsers: SharedFolderUser[];

  /**
   * @generated from field: repeated Vault.SharedFolderTeam sharedFolderTeams = 16;
   */
  sharedFolderTeams: SharedFolderTeam[];

  /**
   * @generated from field: repeated bytes recordAddAuditData = 17;
   */
  recordAddAuditData: Uint8Array[];

  /**
   * @generated from field: repeated Vault.Team teams = 18;
   */
  teams: Team[];

  /**
   * @generated from field: repeated Vault.SharingChange sharingChanges = 19;
   */
  sharingChanges: SharingChange[];

  /**
   * @generated from field: Vault.Profile profile = 20;
   */
  profile?: Profile;

  /**
   * @generated from field: Vault.ProfilePic profilePic = 21;
   */
  profilePic?: ProfilePic;

  /**
   * @generated from field: repeated Vault.PendingTeamMember pendingTeamMembers = 22;
   */
  pendingTeamMembers: PendingTeamMember[];

  /**
   * @generated from field: repeated Vault.BreachWatchRecord breachWatchRecords = 23;
   */
  breachWatchRecords: BreachWatchRecord[];

  /**
   * @generated from field: repeated Vault.UserAuth userAuths = 24;
   */
  userAuths: UserAuth[];

  /**
   * @generated from field: repeated Vault.BreachWatchSecurityData breachWatchSecurityData = 25;
   */
  breachWatchSecurityData: BreachWatchSecurityData[];

  /**
   * @generated from field: Vault.ReusedPasswords reusedPasswords = 26;
   */
  reusedPasswords?: ReusedPasswords;

  /**
   * @generated from field: repeated bytes removedUserFolders = 27;
   */
  removedUserFolders: Uint8Array[];

  /**
   * @generated from field: repeated bytes removedSharedFolders = 28;
   */
  removedSharedFolders: Uint8Array[];

  /**
   * @generated from field: repeated Vault.UserFolderSharedFolder removedUserFolderSharedFolders = 29;
   */
  removedUserFolderSharedFolders: UserFolderSharedFolder[];

  /**
   * @generated from field: repeated Vault.SharedFolderFolder removedSharedFolderFolders = 30;
   */
  removedSharedFolderFolders: SharedFolderFolder[];

  /**
   * @generated from field: repeated bytes removedRecords = 31;
   */
  removedRecords: Uint8Array[];

  /**
   * @generated from field: repeated Vault.RecordLink removedRecordLinks = 32;
   */
  removedRecordLinks: RecordLink[];

  /**
   * @generated from field: repeated Vault.UserFolderRecord removedUserFolderRecords = 33;
   */
  removedUserFolderRecords: UserFolderRecord[];

  /**
   * @generated from field: repeated Vault.SharedFolderRecord removedSharedFolderRecords = 34;
   */
  removedSharedFolderRecords: SharedFolderRecord[];

  /**
   * @generated from field: repeated Vault.SharedFolderFolderRecord removedSharedFolderFolderRecords = 35;
   */
  removedSharedFolderFolderRecords: SharedFolderFolderRecord[];

  /**
   * @generated from field: repeated Vault.SharedFolderUser removedSharedFolderUsers = 36;
   */
  removedSharedFolderUsers: SharedFolderUser[];

  /**
   * @generated from field: repeated Vault.SharedFolderTeam removedSharedFolderTeams = 37;
   */
  removedSharedFolderTeams: SharedFolderTeam[];

  /**
   * @generated from field: repeated bytes removedTeams = 38;
   */
  removedTeams: Uint8Array[];

  /**
   * @generated from field: repeated Vault.KsmChange ksmAppShares = 39;
   */
  ksmAppShares: KsmChange[];

  /**
   * @generated from field: repeated Vault.KsmChange ksmAppClients = 40;
   */
  ksmAppClients: KsmChange[];

  /**
   * @generated from field: repeated Vault.ShareInvitation shareInvitations = 41;
   */
  shareInvitations: ShareInvitation[];

  /**
   * @generated from field: Vault.SyncDiagnostics diagnostics = 42;
   */
  diagnostics?: SyncDiagnostics;

  /**
   * @generated from field: repeated Vault.RecordRotation recordRotations = 43;
   */
  recordRotations: RecordRotation[];

  /**
   * @generated from field: repeated Vault.User users = 44;
   */
  users: User[];

  /**
   * @generated from field: repeated bytes removedUsers = 45;
   */
  removedUsers: Uint8Array[];

  /**
   * @generated from field: repeated Vault.SecurityScoreData securityScoreData = 46;
   */
  securityScoreData: SecurityScoreData[];

  /**
   * @generated from field: repeated NotificationCenter.NotificationWrapper notificationSync = 47;
   */
  notificationSync: NotificationWrapper[];
};

/**
 * Describes the message Vault.SyncDownResponse.
 * Use `create(SyncDownResponseSchema)` to create a new message.
 */
export const SyncDownResponseSchema: GenMessage<SyncDownResponse> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 1);

/**
 * @generated from message Vault.UserFolder
 */
export type UserFolder = Message<"Vault.UserFolder"> & {
  /**
   * @generated from field: bytes folderUid = 1;
   */
  folderUid: Uint8Array;

  /**
   * @generated from field: bytes parentUid = 2;
   */
  parentUid: Uint8Array;

  /**
   * @generated from field: bytes userFolderKey = 3;
   */
  userFolderKey: Uint8Array;

  /**
   * @generated from field: Records.RecordKeyType keyType = 4;
   */
  keyType: RecordKeyType;

  /**
   * @generated from field: int64 revision = 5;
   */
  revision: bigint;

  /**
   * @generated from field: bytes data = 6;
   */
  data: Uint8Array;
};

/**
 * Describes the message Vault.UserFolder.
 * Use `create(UserFolderSchema)` to create a new message.
 */
export const UserFolderSchema: GenMessage<UserFolder> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 2);

/**
 * @generated from message Vault.SharedFolder
 */
export type SharedFolder = Message<"Vault.SharedFolder"> & {
  /**
   * @generated from field: bytes sharedFolderUid = 1;
   */
  sharedFolderUid: Uint8Array;

  /**
   * @generated from field: int64 revision = 2;
   */
  revision: bigint;

  /**
   * @generated from field: bytes sharedFolderKey = 3;
   */
  sharedFolderKey: Uint8Array;

  /**
   * @generated from field: Records.RecordKeyType keyType = 4;
   */
  keyType: RecordKeyType;

  /**
   * @generated from field: bytes data = 5;
   */
  data: Uint8Array;

  /**
   * @generated from field: bool defaultManageRecords = 6;
   */
  defaultManageRecords: boolean;

  /**
   * @generated from field: bool defaultManageUsers = 7;
   */
  defaultManageUsers: boolean;

  /**
   * @generated from field: bool defaultCanEdit = 8;
   */
  defaultCanEdit: boolean;

  /**
   * @generated from field: bool defaultCanReshare = 9;
   */
  defaultCanReshare: boolean;

  /**
   * @generated from field: Vault.CacheStatus cacheStatus = 10;
   */
  cacheStatus: CacheStatus;

  /**
   * @generated from field: string owner = 11;
   */
  owner: string;

  /**
   * @generated from field: bytes ownerAccountUid = 12;
   */
  ownerAccountUid: Uint8Array;

  /**
   * @generated from field: bytes name = 13;
   */
  name: Uint8Array;
};

/**
 * Describes the message Vault.SharedFolder.
 * Use `create(SharedFolderSchema)` to create a new message.
 */
export const SharedFolderSchema: GenMessage<SharedFolder> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 3);

/**
 * @generated from message Vault.UserFolderSharedFolder
 */
export type UserFolderSharedFolder = Message<"Vault.UserFolderSharedFolder"> & {
  /**
   * @generated from field: bytes folderUid = 1;
   */
  folderUid: Uint8Array;

  /**
   * @generated from field: bytes sharedFolderUid = 2;
   */
  sharedFolderUid: Uint8Array;

  /**
   * @generated from field: int64 revision = 3;
   */
  revision: bigint;
};

/**
 * Describes the message Vault.UserFolderSharedFolder.
 * Use `create(UserFolderSharedFolderSchema)` to create a new message.
 */
export const UserFolderSharedFolderSchema: GenMessage<UserFolderSharedFolder> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 4);

/**
 * @generated from message Vault.SharedFolderFolder
 */
export type SharedFolderFolder = Message<"Vault.SharedFolderFolder"> & {
  /**
   * @generated from field: bytes sharedFolderUid = 1;
   */
  sharedFolderUid: Uint8Array;

  /**
   * @generated from field: bytes folderUid = 2;
   */
  folderUid: Uint8Array;

  /**
   * @generated from field: bytes parentUid = 3;
   */
  parentUid: Uint8Array;

  /**
   * @generated from field: bytes sharedFolderFolderKey = 4;
   */
  sharedFolderFolderKey: Uint8Array;

  /**
   * @generated from field: Records.RecordKeyType keyType = 5;
   */
  keyType: RecordKeyType;

  /**
   * @generated from field: int64 revision = 6;
   */
  revision: bigint;

  /**
   * @generated from field: bytes data = 7;
   */
  data: Uint8Array;
};

/**
 * Describes the message Vault.SharedFolderFolder.
 * Use `create(SharedFolderFolderSchema)` to create a new message.
 */
export const SharedFolderFolderSchema: GenMessage<SharedFolderFolder> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 5);

/**
 * @generated from message Vault.SharedFolderKey
 */
export type SharedFolderKey = Message<"Vault.SharedFolderKey"> & {
  /**
   * @generated from field: bytes sharedFolderUid = 1;
   */
  sharedFolderUid: Uint8Array;

  /**
   * @generated from field: bytes sharedFolderKey = 2;
   */
  sharedFolderKey: Uint8Array;

  /**
   * @generated from field: Records.RecordKeyType keyType = 3;
   */
  keyType: RecordKeyType;
};

/**
 * Describes the message Vault.SharedFolderKey.
 * Use `create(SharedFolderKeySchema)` to create a new message.
 */
export const SharedFolderKeySchema: GenMessage<SharedFolderKey> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 6);

/**
 * @generated from message Vault.Team
 */
export type Team = Message<"Vault.Team"> & {
  /**
   * @generated from field: bytes teamUid = 1;
   */
  teamUid: Uint8Array;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bytes teamKey = 3;
   */
  teamKey: Uint8Array;

  /**
   * @generated from field: Records.RecordKeyType teamKeyType = 4;
   */
  teamKeyType: RecordKeyType;

  /**
   * @generated from field: bytes teamPrivateKey = 5;
   */
  teamPrivateKey: Uint8Array;

  /**
   * @generated from field: bool restrictEdit = 6;
   */
  restrictEdit: boolean;

  /**
   * @generated from field: bool restrictShare = 7;
   */
  restrictShare: boolean;

  /**
   * @generated from field: bool restrictView = 8;
   */
  restrictView: boolean;

  /**
   * @generated from field: repeated bytes removedSharedFolders = 9;
   */
  removedSharedFolders: Uint8Array[];

  /**
   * @generated from field: repeated Vault.SharedFolderKey sharedFolderKeys = 10;
   */
  sharedFolderKeys: SharedFolderKey[];

  /**
   * @generated from field: bytes teamEccPrivateKey = 11;
   */
  teamEccPrivateKey: Uint8Array;

  /**
   * @generated from field: bytes teamEccPublicKey = 12;
   */
  teamEccPublicKey: Uint8Array;
};

/**
 * Describes the message Vault.Team.
 * Use `create(TeamSchema)` to create a new message.
 */
export const TeamSchema: GenMessage<Team> = /*@__PURE__*/ messageDesc(file_sync_down, 7);

/**
 * @generated from message Vault.Record
 */
export type Record = Message<"Vault.Record"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: int64 revision = 2;
   */
  revision: bigint;

  /**
   * @generated from field: int32 version = 3;
   */
  version: number;

  /**
   * @generated from field: bool shared = 4;
   */
  shared: boolean;

  /**
   * @generated from field: int64 clientModifiedTime = 5;
   */
  clientModifiedTime: bigint;

  /**
   * @generated from field: bytes data = 6;
   */
  data: Uint8Array;

  /**
   * @generated from field: bytes extra = 7;
   */
  extra: Uint8Array;

  /**
   * @generated from field: string udata = 8;
   */
  udata: string;

  /**
   * @generated from field: int64 fileSize = 9;
   */
  fileSize: bigint;

  /**
   * @generated from field: int64 thumbnailSize = 10;
   */
  thumbnailSize: bigint;
};

/**
 * Describes the message Vault.Record.
 * Use `create(RecordSchema)` to create a new message.
 */
export const RecordSchema: GenMessage<Record> = /*@__PURE__*/ messageDesc(file_sync_down, 8);

/**
 * @generated from message Vault.RecordLink
 */
export type RecordLink = Message<"Vault.RecordLink"> & {
  /**
   * @generated from field: bytes parentRecordUid = 1;
   */
  parentRecordUid: Uint8Array;

  /**
   * @generated from field: bytes childRecordUid = 2;
   */
  childRecordUid: Uint8Array;

  /**
   * @generated from field: bytes recordKey = 3;
   */
  recordKey: Uint8Array;

  /**
   * @generated from field: int64 revision = 4;
   */
  revision: bigint;
};

/**
 * Describes the message Vault.RecordLink.
 * Use `create(RecordLinkSchema)` to create a new message.
 */
export const RecordLinkSchema: GenMessage<RecordLink> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 9);

/**
 * @generated from message Vault.UserFolderRecord
 */
export type UserFolderRecord = Message<"Vault.UserFolderRecord"> & {
  /**
   * @generated from field: bytes folderUid = 1;
   */
  folderUid: Uint8Array;

  /**
   * @generated from field: bytes recordUid = 2;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: int64 revision = 3;
   */
  revision: bigint;
};

/**
 * Describes the message Vault.UserFolderRecord.
 * Use `create(UserFolderRecordSchema)` to create a new message.
 */
export const UserFolderRecordSchema: GenMessage<UserFolderRecord> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 10);

/**
 * @generated from message Vault.SharedFolderFolderRecord
 */
export type SharedFolderFolderRecord = Message<"Vault.SharedFolderFolderRecord"> & {
  /**
   * @generated from field: bytes sharedFolderUid = 1;
   */
  sharedFolderUid: Uint8Array;

  /**
   * @generated from field: bytes folderUid = 2;
   */
  folderUid: Uint8Array;

  /**
   * @generated from field: bytes recordUid = 3;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: int64 revision = 4;
   */
  revision: bigint;
};

/**
 * Describes the message Vault.SharedFolderFolderRecord.
 * Use `create(SharedFolderFolderRecordSchema)` to create a new message.
 */
export const SharedFolderFolderRecordSchema: GenMessage<SharedFolderFolderRecord> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 11);

/**
 * @generated from message Vault.NonSharedData
 */
export type NonSharedData = Message<"Vault.NonSharedData"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;
};

/**
 * Describes the message Vault.NonSharedData.
 * Use `create(NonSharedDataSchema)` to create a new message.
 */
export const NonSharedDataSchema: GenMessage<NonSharedData> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 12);

/**
 * @generated from message Vault.RecordMetaData
 */
export type RecordMetaData = Message<"Vault.RecordMetaData"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bool owner = 2;
   */
  owner: boolean;

  /**
   * @generated from field: bytes recordKey = 3;
   */
  recordKey: Uint8Array;

  /**
   * @generated from field: Records.RecordKeyType recordKeyType = 4;
   */
  recordKeyType: RecordKeyType;

  /**
   * @generated from field: bool canShare = 5;
   */
  canShare: boolean;

  /**
   * @generated from field: bool canEdit = 6;
   */
  canEdit: boolean;

  /**
   * @generated from field: bytes ownerAccountUid = 7;
   */
  ownerAccountUid: Uint8Array;

  /**
   * @generated from field: int64 expiration = 8;
   */
  expiration: bigint;

  /**
   * @generated from field: Records.TimerNotificationType expirationNotificationType = 9;
   */
  expirationNotificationType: TimerNotificationType;

  /**
   * @generated from field: string ownerUsername = 10;
   */
  ownerUsername: string;
};

/**
 * Describes the message Vault.RecordMetaData.
 * Use `create(RecordMetaDataSchema)` to create a new message.
 */
export const RecordMetaDataSchema: GenMessage<RecordMetaData> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 13);

/**
 * @generated from message Vault.SharingChange
 */
export type SharingChange = Message<"Vault.SharingChange"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bool shared = 2;
   */
  shared: boolean;
};

/**
 * Describes the message Vault.SharingChange.
 * Use `create(SharingChangeSchema)` to create a new message.
 */
export const SharingChangeSchema: GenMessage<SharingChange> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 14);

/**
 * @generated from message Vault.Profile
 */
export type Profile = Message<"Vault.Profile"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string profileName = 2;
   */
  profileName: string;

  /**
   * @generated from field: int64 revision = 3;
   */
  revision: bigint;
};

/**
 * Describes the message Vault.Profile.
 * Use `create(ProfileSchema)` to create a new message.
 */
export const ProfileSchema: GenMessage<Profile> = /*@__PURE__*/ messageDesc(file_sync_down, 15);

/**
 * @generated from message Vault.ProfilePic
 */
export type ProfilePic = Message<"Vault.ProfilePic"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: int64 revision = 2;
   */
  revision: bigint;
};

/**
 * Describes the message Vault.ProfilePic.
 * Use `create(ProfilePicSchema)` to create a new message.
 */
export const ProfilePicSchema: GenMessage<ProfilePic> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 16);

/**
 * @generated from message Vault.PendingTeamMember
 */
export type PendingTeamMember = Message<"Vault.PendingTeamMember"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: bytes userPublicKey = 2;
   */
  userPublicKey: Uint8Array;

  /**
   * @generated from field: repeated bytes teamUids = 3;
   */
  teamUids: Uint8Array[];

  /**
   * @generated from field: bytes userEccPublicKey = 4;
   */
  userEccPublicKey: Uint8Array;
};

/**
 * Describes the message Vault.PendingTeamMember.
 * Use `create(PendingTeamMemberSchema)` to create a new message.
 */
export const PendingTeamMemberSchema: GenMessage<PendingTeamMember> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 17);

/**
 * @generated from message Vault.BreachWatchRecord
 */
export type BreachWatchRecord = Message<"Vault.BreachWatchRecord"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;

  /**
   * @generated from field: BreachWatch.BreachWatchInfoType type = 3;
   */
  type: BreachWatchInfoType;

  /**
   * @generated from field: string scannedBy = 4;
   */
  scannedBy: string;

  /**
   * @generated from field: int64 revision = 5;
   */
  revision: bigint;

  /**
   * @generated from field: bytes scannedByAccountUid = 6;
   */
  scannedByAccountUid: Uint8Array;
};

/**
 * Describes the message Vault.BreachWatchRecord.
 * Use `create(BreachWatchRecordSchema)` to create a new message.
 */
export const BreachWatchRecordSchema: GenMessage<BreachWatchRecord> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 18);

/**
 * @generated from message Vault.UserAuth
 */
export type UserAuth = Message<"Vault.UserAuth"> & {
  /**
   * @generated from field: bytes uid = 1;
   */
  uid: Uint8Array;

  /**
   * @generated from field: Authentication.LoginType loginType = 2;
   */
  loginType: LoginType;

  /**
   * @generated from field: bool deleted = 3;
   */
  deleted: boolean;

  /**
   * @generated from field: int32 iterations = 4;
   */
  iterations: number;

  /**
   * @generated from field: bytes salt = 5;
   */
  salt: Uint8Array;

  /**
   * @generated from field: bytes encryptedClientKey = 6;
   */
  encryptedClientKey: Uint8Array;

  /**
   * @generated from field: int64 revision = 7;
   */
  revision: bigint;

  /**
   * @generated from field: string name = 8;
   */
  name: string;
};

/**
 * Describes the message Vault.UserAuth.
 * Use `create(UserAuthSchema)` to create a new message.
 */
export const UserAuthSchema: GenMessage<UserAuth> = /*@__PURE__*/ messageDesc(file_sync_down, 19);

/**
 * @generated from message Vault.BreachWatchSecurityData
 */
export type BreachWatchSecurityData = Message<"Vault.BreachWatchSecurityData"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: int64 revision = 2;
   */
  revision: bigint;
};

/**
 * Describes the message Vault.BreachWatchSecurityData.
 * Use `create(BreachWatchSecurityDataSchema)` to create a new message.
 */
export const BreachWatchSecurityDataSchema: GenMessage<BreachWatchSecurityData> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 20);

/**
 * @generated from message Vault.ReusedPasswords
 */
export type ReusedPasswords = Message<"Vault.ReusedPasswords"> & {
  /**
   * @generated from field: int32 count = 1;
   */
  count: number;

  /**
   * @generated from field: int64 revision = 2;
   */
  revision: bigint;
};

/**
 * Describes the message Vault.ReusedPasswords.
 * Use `create(ReusedPasswordsSchema)` to create a new message.
 */
export const ReusedPasswordsSchema: GenMessage<ReusedPasswords> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 21);

/**
 * @generated from message Vault.SharedFolderRecord
 */
export type SharedFolderRecord = Message<"Vault.SharedFolderRecord"> & {
  /**
   * @generated from field: bytes sharedFolderUid = 1;
   */
  sharedFolderUid: Uint8Array;

  /**
   * @generated from field: bytes recordUid = 2;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes recordKey = 3;
   */
  recordKey: Uint8Array;

  /**
   * @generated from field: bool canShare = 4;
   */
  canShare: boolean;

  /**
   * @generated from field: bool canEdit = 5;
   */
  canEdit: boolean;

  /**
   * @generated from field: bytes ownerAccountUid = 6;
   */
  ownerAccountUid: Uint8Array;

  /**
   * @generated from field: int64 expiration = 7;
   */
  expiration: bigint;

  /**
   * @generated from field: bool owner = 8;
   */
  owner: boolean;

  /**
   * @generated from field: Records.TimerNotificationType expirationNotificationType = 9;
   */
  expirationNotificationType: TimerNotificationType;

  /**
   * @generated from field: string ownerUsername = 10;
   */
  ownerUsername: string;

  /**
   * @generated from field: bool rotateOnExpiration = 11;
   */
  rotateOnExpiration: boolean;
};

/**
 * Describes the message Vault.SharedFolderRecord.
 * Use `create(SharedFolderRecordSchema)` to create a new message.
 */
export const SharedFolderRecordSchema: GenMessage<SharedFolderRecord> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 22);

/**
 * @generated from message Vault.SharedFolderUser
 */
export type SharedFolderUser = Message<"Vault.SharedFolderUser"> & {
  /**
   * @generated from field: bytes sharedFolderUid = 1;
   */
  sharedFolderUid: Uint8Array;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: bool manageRecords = 3;
   */
  manageRecords: boolean;

  /**
   * @generated from field: bool manageUsers = 4;
   */
  manageUsers: boolean;

  /**
   * @generated from field: bytes accountUid = 5;
   */
  accountUid: Uint8Array;

  /**
   * @generated from field: int64 expiration = 6;
   */
  expiration: bigint;

  /**
   * @generated from field: Records.TimerNotificationType expirationNotificationType = 7;
   */
  expirationNotificationType: TimerNotificationType;

  /**
   * @generated from field: bool rotateOnExpiration = 8;
   */
  rotateOnExpiration: boolean;
};

/**
 * Describes the message Vault.SharedFolderUser.
 * Use `create(SharedFolderUserSchema)` to create a new message.
 */
export const SharedFolderUserSchema: GenMessage<SharedFolderUser> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 23);

/**
 * @generated from message Vault.SharedFolderTeam
 */
export type SharedFolderTeam = Message<"Vault.SharedFolderTeam"> & {
  /**
   * @generated from field: bytes sharedFolderUid = 1;
   */
  sharedFolderUid: Uint8Array;

  /**
   * @generated from field: bytes teamUid = 2;
   */
  teamUid: Uint8Array;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: bool manageRecords = 4;
   */
  manageRecords: boolean;

  /**
   * @generated from field: bool manageUsers = 5;
   */
  manageUsers: boolean;

  /**
   * @generated from field: int64 expiration = 6;
   */
  expiration: bigint;

  /**
   * @generated from field: Records.TimerNotificationType expirationNotificationType = 7;
   */
  expirationNotificationType: TimerNotificationType;

  /**
   * @generated from field: bool rotateOnExpiration = 8;
   */
  rotateOnExpiration: boolean;
};

/**
 * Describes the message Vault.SharedFolderTeam.
 * Use `create(SharedFolderTeamSchema)` to create a new message.
 */
export const SharedFolderTeamSchema: GenMessage<SharedFolderTeam> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 24);

/**
 * @generated from message Vault.KsmChange
 */
export type KsmChange = Message<"Vault.KsmChange"> & {
  /**
   * @generated from field: bytes appRecordUid = 1;
   */
  appRecordUid: Uint8Array;

  /**
   * @generated from field: bytes detailId = 2;
   */
  detailId: Uint8Array;

  /**
   * @generated from field: bool removed = 3;
   */
  removed: boolean;

  /**
   * @generated from field: Enterprise.AppClientType appClientType = 4;
   */
  appClientType: AppClientType;

  /**
   * @generated from field: int64 expiration = 5;
   */
  expiration: bigint;
};

/**
 * Describes the message Vault.KsmChange.
 * Use `create(KsmChangeSchema)` to create a new message.
 */
export const KsmChangeSchema: GenMessage<KsmChange> = /*@__PURE__*/ messageDesc(file_sync_down, 25);

/**
 * @generated from message Vault.ShareInvitation
 */
export type ShareInvitation = Message<"Vault.ShareInvitation"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;
};

/**
 * Describes the message Vault.ShareInvitation.
 * Use `create(ShareInvitationSchema)` to create a new message.
 */
export const ShareInvitationSchema: GenMessage<ShareInvitation> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 26);

/**
 * @generated from message Vault.User
 */
export type User = Message<"Vault.User"> & {
  /**
   * @generated from field: bytes accountUid = 1;
   */
  accountUid: Uint8Array;

  /**
   * @generated from field: string username = 2;
   */
  username: string;
};

/**
 * Describes the message Vault.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/ messageDesc(file_sync_down, 27);

/**
 * @generated from message Vault.SyncDiagnostics
 */
export type SyncDiagnostics = Message<"Vault.SyncDiagnostics"> & {
  /**
   * @generated from field: bytes continuationToken = 1;
   */
  continuationToken: Uint8Array;

  /**
   * @generated from field: int32 userId = 2;
   */
  userId: number;

  /**
   * @generated from field: int64 enterpriseUserId = 3;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: int64 syncedTo = 4;
   */
  syncedTo: bigint;

  /**
   * @generated from field: int64 syncingTo = 5;
   */
  syncingTo: bigint;
};

/**
 * Describes the message Vault.SyncDiagnostics.
 * Use `create(SyncDiagnosticsSchema)` to create a new message.
 */
export const SyncDiagnosticsSchema: GenMessage<SyncDiagnostics> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 28);

/**
 * @generated from message Vault.RecordRotation
 */
export type RecordRotation = Message<"Vault.RecordRotation"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: int64 revision = 2;
   */
  revision: bigint;

  /**
   * @generated from field: bytes configurationUid = 3;
   */
  configurationUid: Uint8Array;

  /**
   * @generated from field: string schedule = 4;
   */
  schedule: string;

  /**
   * @generated from field: bytes pwdComplexity = 5;
   */
  pwdComplexity: Uint8Array;

  /**
   * @generated from field: bool disabled = 6;
   */
  disabled: boolean;

  /**
   * @generated from field: bytes resourceUid = 7;
   */
  resourceUid: Uint8Array;

  /**
   * @generated from field: int64 lastRotation = 8;
   */
  lastRotation: bigint;

  /**
   * @generated from field: Vault.RecordRotationStatus lastRotationStatus = 9;
   */
  lastRotationStatus: RecordRotationStatus;
};

/**
 * Describes the message Vault.RecordRotation.
 * Use `create(RecordRotationSchema)` to create a new message.
 */
export const RecordRotationSchema: GenMessage<RecordRotation> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 29);

/**
 * @generated from message Vault.SecurityScoreData
 */
export type SecurityScoreData = Message<"Vault.SecurityScoreData"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;

  /**
   * @generated from field: int64 revision = 3;
   */
  revision: bigint;
};

/**
 * Describes the message Vault.SecurityScoreData.
 * Use `create(SecurityScoreDataSchema)` to create a new message.
 */
export const SecurityScoreDataSchema: GenMessage<SecurityScoreData> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 30);

/**
 * @generated from message Vault.BreachWatchGetSyncDataRequest
 */
export type BreachWatchGetSyncDataRequest = Message<"Vault.BreachWatchGetSyncDataRequest"> & {
  /**
   * @generated from field: repeated bytes recordUids = 1;
   */
  recordUids: Uint8Array[];
};

/**
 * Describes the message Vault.BreachWatchGetSyncDataRequest.
 * Use `create(BreachWatchGetSyncDataRequestSchema)` to create a new message.
 */
export const BreachWatchGetSyncDataRequestSchema: GenMessage<BreachWatchGetSyncDataRequest> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 31);

/**
 * @generated from message Vault.BreachWatchGetSyncDataResponse
 */
export type BreachWatchGetSyncDataResponse = Message<"Vault.BreachWatchGetSyncDataResponse"> & {
  /**
   * @generated from field: repeated Vault.BreachWatchRecord breachWatchRecords = 1;
   */
  breachWatchRecords: BreachWatchRecord[];

  /**
   * @generated from field: repeated Vault.BreachWatchSecurityData breachWatchSecurityData = 2;
   */
  breachWatchSecurityData: BreachWatchSecurityData[];

  /**
   * @generated from field: repeated Vault.User users = 3;
   */
  users: User[];
};

/**
 * Describes the message Vault.BreachWatchGetSyncDataResponse.
 * Use `create(BreachWatchGetSyncDataResponseSchema)` to create a new message.
 */
export const BreachWatchGetSyncDataResponseSchema: GenMessage<BreachWatchGetSyncDataResponse> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 32);

/**
 * @generated from message Vault.GetAccountUidMapResponse
 */
export type GetAccountUidMapResponse = Message<"Vault.GetAccountUidMapResponse"> & {
  /**
   * @generated from field: repeated Vault.User users = 1;
   */
  users: User[];
};

/**
 * Describes the message Vault.GetAccountUidMapResponse.
 * Use `create(GetAccountUidMapResponseSchema)` to create a new message.
 */
export const GetAccountUidMapResponseSchema: GenMessage<GetAccountUidMapResponse> =
  /*@__PURE__*/
  messageDesc(file_sync_down, 33);

/**
 * @generated from enum Vault.CacheStatus
 */
export enum CacheStatus {
  /**
   * @generated from enum value: KEEP = 0;
   */
  KEEP = 0,

  /**
   * @generated from enum value: CLEAR = 1;
   */
  CLEAR = 1,
}

/**
 * Describes the enum Vault.CacheStatus.
 */
export const CacheStatusSchema: GenEnum<CacheStatus> = /*@__PURE__*/ enumDesc(file_sync_down, 0);

/**
 * @generated from enum Vault.RecordRotationStatus
 */
export enum RecordRotationStatus {
  /**
   * @generated from enum value: RRST_NOT_ROTATED = 0;
   */
  RRST_NOT_ROTATED = 0,

  /**
   * @generated from enum value: RRST_IN_PROGRESS = 1;
   */
  RRST_IN_PROGRESS = 1,

  /**
   * @generated from enum value: RRST_SUCCESS = 2;
   */
  RRST_SUCCESS = 2,

  /**
   * @generated from enum value: RRST_FAILURE = 3;
   */
  RRST_FAILURE = 3,
}

/**
 * Describes the enum Vault.RecordRotationStatus.
 */
export const RecordRotationStatusSchema: GenEnum<RecordRotationStatus> =
  /*@__PURE__*/
  enumDesc(file_sync_down, 1);
